import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";
function useCustomerList(params) {
  return useSWR(
    !!params
      ? {
          path: `/api/v1/customers`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useCustomerList;
